import React from "react";
import { Button } from "../../components/buttons";
import { Input } from "../../components/inputs";

const AddExam = ({
  examCode,
  examTitle,
  examOrder,
  setExamCode,
  setExamTitle,
  setExamOrder,
  submitExam,
}) => {
  return (
    <>
      <div className="h-100 overflow-auto ">
        <div className="container mt-3">
          <div className="d-flex flex-row justify-content-around mb-4 ">
            <div className="border p-3 w-40 ">
              <h6>Add Exam</h6>

              <Input
                id="examCode"
                type={"text"}
                label="Exam Code"
                value={examCode}
                onChange={setExamCode}
              />
              <Input
                id="examTitle"
                type={"text"}
                label="Exam Title"
                value={examTitle}
                onChange={setExamTitle}
              />
              <Input
                id="examOrder"
                type={"number"}
                label="Rank"
                value={examOrder}
                onChange={setExamOrder}
              />
              <div>
                <Button
                  className="outline"
                  width="25"
                  disabled={!examCode || !examTitle}
                  onClick={submitExam}
                >
                  Submit
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AddExam;
